export const APP_VERSION = '1.2.1';
export const LAST_UPDATED = '2026-02-06';
export const BUILD_NUMBER = '20260206-2';

export const VERSION_HISTORY = [
  {
    version: '1.2.1',
    date: '2026-02-06',
    changes: [
      'Replaced annoying beep alarm with "The Sound of Silence" remix',
      'Fixed music looping issue - now plays continuously',
      'Added version control display',
      'Fixed music playback to not restart on each notification'
    ]
  },
  {
    version: '1.2.0',
    date: '2026-02-06',
    changes: [
      'Added 4 new task categories (Internal Meeting, Cleaning/Organisation, Taking a Shit, Custom Task)',
      'Added custom task input feature',
      'Updated to new domain: bro.3dprintergear.com.au',
      'Added PWA install prompt',
      'Apple-style typography',
      'Animated fist bump logo'
    ]
  },
  {
    version: '1.1.0',
    date: '2026-02-05',
    changes: [
      'Added timeline bar visualization for user day breakdown',
      'Added active users list in admin panel',
      'Fixed mobile pie chart overlap',
      'Added system notification tray support',
      'Improved mobile responsive design'
    ]
  },
  {
    version: '1.0.0',
    date: '2026-02-05',
    changes: [
      'Initial release',
      'User authentication with PIN',
      'Timer with 15-minute intervals',
      'Admin dashboard with analytics',
      'CSV export functionality',
      'Mobile-optimized PWA'
    ]
  }
];
